// @flow
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import _debug from 'debug';
import { responsiveStoreEnhancer } from 'redux-responsive';
import createMiddleware from './middleware/clientMiddleware';
import promiseMiddleware from './middleware/promiseMiddleware';
import facebookMiddleware from './middleware/facebookMiddleware';
import geolocationMiddleware from './middleware/geolocationMiddleware';
import { actionListenersStoreEnhancer } from './components/Decorators/withAnalytics';
import reducer from './stores/reducer';

declare var __CLIENT__: boolean;
declare var __DEVELOPMENT__: boolean;

const staticReducers = reducer();

const debug = _debug('jp:store');

function createReducer(asyncReducers) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers
  });
}

export default function createStore(
  client,
  data,
  t,
  jpApiClient,
  asyncReducers = {}
) {
  // Sync dispatched route actions to the history
  const thunkExtra = { client, t, jpApiClient };

  const middleware = [
    thunk.withExtraArgument(thunkExtra),
    promiseMiddleware,
    facebookMiddleware,
    geolocationMiddleware,
    createMiddleware(client)
  ];

  const enhancers = [responsiveStoreEnhancer, actionListenersStoreEnhancer];

  const store = configureStore({
    reducer: createReducer(asyncReducers),
    middleware,
    devTools: __DEVELOPMENT__,
    preloadedState: data,
    enhancers
  });

  // Add a dictionary to keep track of the registered async reducers
  store.asyncReducers = asyncReducers;

  // Create an inject reducer function
  // This function adds the async reducer, and creates a new combined reducer
  store.injectReducer = (slice) => {
    const key = slice.name;

    if (key in store.asyncReducers) {
      debug(`${key} already injected`);
      return;
    }

    store.asyncReducers[key] = slice.reducer;

    debug(`injecting reducer ${key}`);
    store.replaceReducer(createReducer(store.asyncReducers));
  };

  if (__CLIENT__ && window.Cypress) {
    window.store = store;
  }

  return store;
}
